(function () {
  'use strict';

  function hideKaching() {
    var els = document.querySelectorAll('.kaching-subscriptions__widget, .kaching-subscriptions__cards-wrapper, .ks-card-wrapper, .ks-discount-label-wrapper');
    els.forEach(function (el) { if (el.style.display !== 'none') el.style.display = 'none'; });
  }

  function findForm() {
    return document.querySelector('product-form form[action*="/cart/add"]')
      || document.querySelector('form[action*="/cart/add"]');
  }

  function ensureInput(form, name) {
    if (!form) return null;
    var i = form.querySelector('input[name="' + name + '"]');
    if (!i) { i = document.createElement('input'); i.type = 'hidden'; i.name = name; form.appendChild(i); }
    return i;
  }

  function init() {
    var box = document.querySelector('[data-im8-buybox]');
    if (!box) return false;
    hideKaching();

    var form = findForm();

    // The supply tier (90/30) the customer last chose; One-Time mirrors its pack count.
    var lastSupply = '90';
    var checked = box.querySelector('.im8-tier__input:checked');
    if (checked && (checked.value === '90' || checked.value === '30')) lastSupply = checked.value;

    // While true, the capture-phase re-assert is skipped so a programmatic one-time
    // add can submit its own form values without being overwritten.
    var suppressReassert = false;

    function oneTimeQty() {
      return lastSupply === '30' ? (box.getAttribute('data-qty-30') || '1') : (box.getAttribute('data-qty-90') || '3');
    }
    function oneTimePrice() {
      return lastSupply === '30' ? (box.getAttribute('data-onetime-30') || '') : (box.getAttribute('data-onetime-90') || '');
    }
    function updateOneTimeLabel() {
      var el = box.querySelector('.im8-onetime__price');
      if (el) el.textContent = oneTimePrice();
    }

    function setForm(planId, qty) {
      if (!form) return;
      var sp = ensureInput(form, 'selling_plan');
      if (sp) {
        if (planId) { sp.value = planId; sp.disabled = false; }
        else { sp.value = ''; sp.disabled = true; }
      }
      var q = ensureInput(form, 'quantity');
      if (q) q.value = qty;
    }

    // Apply the currently-selected subscription tier (90/30) to the form + visuals.
    function apply() {
      var sel = box.querySelector('.im8-tier__input:checked');
      if (!sel) return;
      var tier = sel.value, planId = '', qty = '1';
      if (tier === '90') { planId = box.getAttribute('data-plan-90') || ''; qty = box.getAttribute('data-qty-90') || '3'; lastSupply = '90'; }
      else if (tier === '30') { planId = box.getAttribute('data-plan-30') || ''; qty = box.getAttribute('data-qty-30') || '1'; lastSupply = '30'; }

      box.querySelectorAll('.im8-tier').forEach(function (l) { l.classList.remove('is-selected'); });
      var lbl = sel.closest('.im8-tier');
      if (lbl) lbl.classList.add('is-selected');

      updateOneTimeLabel();
      setForm(planId, qty);
      box.setAttribute('data-current-tier', tier);
    }

    box.addEventListener('change', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('im8-tier__input')) apply();
    });

    // One-Time: add the active tier's pack count at full price (no plan) RIGHT NOW,
    // leaving the subscription radio untouched, then restore the subscription form.
    var oneBtn = box.querySelector('[data-im8-onetime]');
    if (oneBtn) {
      oneBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (!form) return;
        var submitBtn = form.querySelector('.product-form__submit') || form.querySelector('[type="submit"]');
        if (!submitBtn) return;
        setForm('', oneTimeQty());     // no selling plan, active-tier pack count
        suppressReassert = true;
        submitBtn.click();              // reuse theme add-to-cart + Kaching cart drawer
        setTimeout(function () { suppressReassert = false; apply(); }, 0); // restore subscription
      });
    }

    // Re-assert selling_plan + quantity right before the real (subscription) Add to Cart.
    document.addEventListener('click', function (e) {
      if (suppressReassert) return;
      var btn = e.target.closest && e.target.closest('.product-form__submit, [type="submit"]');
      if (btn && form && form.contains(btn)) apply();
    }, true);

    updateOneTimeLabel();
    apply();
    return true;
  }

  function boot() {
    var ready = init();
    var observer = new MutationObserver(function () {
      if (!ready) ready = init();
      hideKaching();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    if (!ready) {
      var n = 0;
      var poll = setInterval(function () { n++; if (init() || n > 60) clearInterval(poll); }, 500);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
